import { useEventListener } from '@passkeys/hooks';
import type { ReactElement } from 'react';
import { useCallback } from 'react';

export enum BlockchainRedirectReason {
  PaymentProcessed = 'AUTO_REDIRECT_AFTER_PAYMENT_PROCESSED',
}

type BlockchainEventPayloadRedirect = {
  reason: BlockchainRedirectReason | string;
};

enum BlockchainEvent {
  Redirect = 'REDIRECT',
}

type BlockchainMessageData = {
  event: BlockchainEvent | string;
  payload: BlockchainEventPayloadRedirect;
};

type BlockchainWidgetProps = {
  src: string;
  onPaymentProcessed: () => void;
};

const BlockchainWidget = ({
  src,
  onPaymentProcessed,
}: BlockchainWidgetProps): ReactElement | null => {
  const handleMessage = useCallback(
    (event: MessageEvent<BlockchainMessageData>) => {
      if (event.data?.event !== BlockchainEvent.Redirect) {
        return;
      }

      if (
        event.data.payload.reason === BlockchainRedirectReason.PaymentProcessed
      ) {
        onPaymentProcessed();
      }
    },
    [onPaymentProcessed],
  );

  useEventListener('message', handleMessage);

  return (
    <iframe
      className="size-full rounded-2xl shadow-md"
      title="Blockchain.com Buy Widget"
      src={src}
      allow="autoplay *; camera *; microphone *; fullscreen *; accelerometer *; magnetometer *; gyroscope *; picture-in-picture *; payment *"
    />
  );
};

export default BlockchainWidget;
